<input type="checkbox"
       [checked]="isActive">
<label>{{ viewValue }} <span class="ng-filter-value-count">({{ count }})</span></label>